import type { InputHTMLAttributes } from 'react';

/** True on iOS/iPadOS, whose numeric/decimal keypads have no minus key. */
export function isIos(): boolean {
  if (typeof navigator === 'undefined') return false;
  if (/iPad|iPhone|iPod/.test(navigator.userAgent)) return true;
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
}

/**
 * Input props for a decimal field that must accept a negative value. iOS keypads
 * omit the minus key, so there we fall back to the full keyboard (its "123" page
 * has a minus) and rely on sanitisation to reject non-numeric input; elsewhere the
 * decimal keypad already offers a minus.
 */
export function signedDecimalInputProps(): Pick<
  InputHTMLAttributes<HTMLInputElement>,
  'inputMode' | 'autoCapitalize' | 'autoCorrect' | 'spellCheck'
> {
  return {
    // inputMode: isIos() ? "text" : "decimal",
    inputMode: 'text',
    autoCapitalize: 'off',
    autoCorrect: 'off',
    spellCheck: false,
  };
}
